<template>
  <v-row dense>
    <v-col
      v-for="staffMember in staffMembers"
      :key="staffMember.id"
      cols="12"
      lg="6"
    >
      <v-card
        class="pa-1"
        data-testid="public-staff-member-card"
        border
        flat
        tile
      >
        <v-card-text>
          <template v-if="staffMember.attachment_url">
            <v-row class="mb-2">
              <v-col>
                <v-img
                  :alt="`${$bct('Picture for')} ${staffMember.name}`"
                  :src="staffMember.attachment_url"
                  height="160"
                />
              </v-col>
            </v-row>
          </template>
          <v-row dense>
            <v-col>
              <div class="fw-600 fs-16 fw-500">
                {{ staffMember.name }}
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-3" />
          <v-row>
            <v-col>
              <div class="fs-16 fw-400">
                {{ $bct(staffMember.bio) }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import useApi from '@/shared/composables/useApi';

const { api: Api } = useApi();

const $bct = inject('translator');

const props = defineProps({
  provider: {
    type: Object,
    default: null,
  },
});

const staffMembers = ref([]);

watch(() => props.provider, load);

function load() {
  Api.publicApi.provider.staff_member.index(props.provider.id, (resp) => {
    staffMembers.value = resp.data;
  });
}

onMounted(load);
</script>
